import { Outlet } from "react-router-dom";
import logo from "../assets/VOPA-sm.png";

export const ResidentLayout = () => {
  return (
    <div className="white-wrapper column">
      <div className="pl-xl py bg-white">
        <img src={logo} alt="logo" className="" width="100px" />{" "}
      </div>
      {/* <div className="img-background"> */}
      {/* <div className="overlay"></div> */}
      <div className="content-wrapper bg-highlight">
        <div className="content page">
          <Outlet />
        </div>
      </div>
      {/* </div> */}
      <div className="text-center p-lg bg-white stretch">
        <img src={logo} alt="logo" className="" width="100px" />{" "}
      </div>
      <div className="footer">
        <span>© Copyright - VOPA Rådgivning</span>
      </div>
    </div>

    // <div className="page">
    //   <Outlet />
    // </div>
  );
};
